<template>
    <layout name="LayoutDefault">
        <div class="About">
            <div class="container">
                <!-- Page Features -->
                <div class="contents min-height">
                    <div class="row ">
                        <div class="col-lg-12 ">
                            <div class="section-items">
                                <div class="row">
                                    <div class="col-lg-12 text-justify">
                                        <ul class="list-group">
                                            <li v-for="(item, key) in downloads" v-bind:key="key" class="list-group-item d-flex justify-content-between align-items-center">
                                                {{item.title}}
                                                <a :href="`${IMAGEURL}${item.image}`" target="_blank" class="badge badge-primary badge-pill">Download</a>
                                            </li>
                                        </ul>
                                        <div v-if="noDataFound">No data found</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.container -->
        </div>
    </layout>
</template>

<script>
    import Layout from '../layouts/Layout';

    export default {
        name: `Home`,
        data() {
            return{
                downloads: [
                    {
                        'image': null,
                        'title': 'Loading...'
                    }
                ],
                noDataFound: false,
            }
        },
        components: {
            Layout,
        },
        methods: {
            getDownloads() {
                fetch(this.APIURL + 'cms-resources/PDF')
                    .then(response => response.json())
                    .then(json => {
                        this.downloads = json.data;
                        //console.log(this.downloads);
                        if(this.downloads.length < 1){
                            this.noDataFound = true;
                        }
                    })
            }
        },
        mounted() {
            this.getDownloads();
        }
    };
</script>
